export default {
    en: {
        language: 'Language',
        test: 'aaa',
        title: 'title',
        message: 'message',
        langCode: 'lang code',
        desc: 'desc',
        createdAt: 'created at',
        updatedAt: 'updated at',
        contentType: 'content type',
        logout: 'logout',
        add: 'add',
        edit: 'edit',
        trash: 'delete',
        deleteSelected: 'delete selected',
        selected: 'selected',
        agreeSelected: 'pass user',
        publish: 'publish',
        unpublish: 'unpublish',
        clear: 'clear',
        submit: 'submit',
        typeContent: 'Content',
        typeDecoration: 'Decoration',
        typeApplication: 'Application',
        filterBy: 'Filter by {column}',
        defaultOption: 'Select {column}',
        bundle: 'bundle',
        goods: 'goods',
        content: 'content',
        decoration: 'decoration',
        isBundle: 'isBundle',
        descGoodsBundle: 'goods bundle',
        descBuildBundle: 'build content bundle',
        decorationBundle: 'decoration bundle',
        buyOnMarket: 'buyOnMarket',
        store: 'store',
        theater: 'theater',
        isStoreOrTheater: 'for store or theater',
        yes: 'Yes',
        no: 'No',
        wishSelf: 'self choose',
        wishStoryContent: 'story content',
        wishStoryVolume: 'story volume',
        wishStoryGoods: 'story goods',
        wishDecorationGoods: 'decoration goods',
        wishDecorationBundle: 'decoration bundle',
        sort: 'sort',
        sortAsc: 'asc',
        sortDesc: 'desc',
        category: 'category',
        channel: 'channel',
        tag: 'tag',
        appType: 'app type',
        preload: 'preload',
        market: 'market',
        size: 'size',
        time: 'time',
        episode: 'episode',
        priority: 'priority',
        status: 'status',
        publishBeginDate: 'publish begin date',
        publishBeginTime: 'publish begin time',
        publishEndDate: 'publish end date',
        publishEndTime: 'publish end time',
        downloadUrl: 'download url',
        bannerUrl: 'banner url',
        imageUrl: 'image url',
        previewImageUrl: 'preview image url',
        previewDownloadUrl: 'preview download url',
        creator: 'creator',
        currency: 'currency',
        price: 'price',
        version: 'version',
        success: 'success',
        playCount: 'play count',
        sellCount: 'sell count',
        commentRank: 'comment rank',
        commentCount: 'comment count',
        flag: 'flag',
        order: 'order',
        typeZHCN: 'Simplified Chinese',
        typeZHTW: 'Traditional Chinese',
        typeEN: 'English',
        descTheaterDetail: 'Theater detail',
        descStoreDetail: 'Store detail',
        descImageUrl: 'Inside page image',
        descPreviewImageUrl: 'Cover image',
        exampleTime: '(30:20 means file time is 30 min 20 sec)',
        exampleEpisode: '(number of episode, for example, 2 for No.2 episode)',
        noPublishEnd: 'no end of publish',
        required: 'required',
        minValue: 'minimum',
        minLength: 'min length',
        all: 'all',
        unPublishMessage: 'un publish it ?',
        deleteMessage: 'delete it ?',
        syncMessage: 'sync this ?',
        publishMessage: 'publish this ?',
        errorMessage: 'Something went wrong',
        confirmMessage: 'ok',
        type: 'type',
        typeStar: 'star',
        typeSell: 'sell',
        typeRecommend: 'recommend',
        descMenuUserList: 'User list',
        descMenuMessageList: 'Message list',
        descMenuAppList: 'APP list',
        descMenuFileList: 'File list',
        descMenuSdkFileList: 'SDK list',
        descMenuSampleFileList: 'Sample code list',
        descMenuDashboard: 'Dashboard',
        descMenuReport: 'Report list',
        descMenuAdminGoodsList: 'Goods list',
        descMenuRecommendList: 'Recommend list',
        descMenuFeedbackList: 'Store feedback list',
        descMenuOrderList: 'Order list',
        descMenuCategoryList: 'Category list',
        descMenuChannelList: 'Channel list',
        descMenuTagList: 'Tag list',
        descMenuMarketList: 'Market list',
        descMenuHotList: 'Store main page list',
        descMenuMiboNewsList: 'Mibo News list',
        descMenuMiboPetVersionList: 'Mibo pet version list',
        descMenuGoodsList: 'Goods list',
        descSync: 'Sync',
        descPublish: 'Publish',
        descPetRefreshInterval: 'Refresh this page per 30 sec',
        descMenuMotionFileList: 'Motion file list',
        descMenuMotionCategoryList: 'Motion category list',
        descMenuMotionTagList: 'Motion tag list',
        descMenuResourceDescription: 'Introduction',
        descMenuRobotSdk: 'NUWA Robot SDK',
        containThisContent: 'Contain this content',
        uploading: 'Uploading',
        email: 'email',
        invalidEmailFormat: 'invalid email format',
        duplicateEmail: 'The mailbox you entered already exists',
        password: 'password',
        confirmPassword: 'password again',
        phone: 'phone',
        companyName: 'company name',
        sameAsPassword: 'The two passwords do not match',
        package: 'package',
        keyName: 'key name',
        platform: 'platform',
        publishSecret: 'publish SHA1',
        testSecret: 'test SHA1',
        appId: 'app Id',
        appKey: 'app key',
        expire: 'expire',
        wantMessage: 'want receive mail ?',
        indexProduct: 'Product',
        indexNews: 'News',
        indexResource: 'Resources',
        indexSDK: 'SDK',
        indexForum: 'Forum',
        indexDoc: 'Doc',
        indexMotion: 'Motion',
        indexSampleCode: 'Sample Code',
        indexRegister: 'Register',
        indexLogin: 'Login',
        indexControlPanel: 'Control panel',
        registerTitle: 'Developer',
        registerFillInfo: 'fill info',
        registerComplete: 'complete info',
        registerFinish: 'register finish',
        registerFinishMessage: 'Waiting for admin verified, please check mail.',
        addApp: 'Add App',
        editApp: 'Edit App',
        motionName: 'motion name',
        motionDescription: 'motion description',
        keyword: 'keyword',
        descAddI18n: 'Add language',
        // [首页]
        buy_now: 'Buy now',
        developer_banner_title_01: 'Live your rich imagination',
        developer_banner_text_01: 'Let your application enter people’s life through nuwa robot',
        developer_feature_step_title: 'Develop my xiaodan app',
        developer_feature_step_text: 'Introduce your service through the following steps',
        developer_feature_support_title: 'Technical support',
        developer_banner_buy: 'Don’t you have your own nuwa robot?',
        developer_documentation_download: 'Download',
        developer_feature_step_store: 'Mall release',
        developer_feature_step_description_store: 'With merchandise on the shelves, a wide range of xiaodan users can start using your merchandise',
        developer_feature_step_product: 'Product validation',
        developer_feature_step_description_product: 'After the project is submitted, Nuwa reviews the application content and programs to ensure compliance',
        developer_feature_step_creat: 'Creation and development',
        developer_feature_step_description_creat: 'Create different projects according to application type, which are application, story and ornament respectively',
        developer_feature_step_sign: 'Login developer',
        developer_feature_step_description_sign: 'Register an account and authenticate the developer to open the feature',
        developer_feature_tool_ai: 'Living speech artificial intelligence',
        developer_feature_tool_description_ai: 'With the help of nuwa robot, xiao ai can quickly apply her strong speech recognition, natural language processing and abundant speech ability',
        developer_feature_tool_motion: 'Free body representation',
        developer_feature_tool_description_motion: 'Built-in MCU microcontroller, support 360 ° rotation, can achieve multi-angle joint action, have more possibilities',
        developer_feature_tool_devtool: 'Convenient development tools',
        developer_feature_tool_description_devtool: 'Action kits are currently available for easy application.Various tools for content development and program development will be introduced in the future',
        developer_banner_store_title: 'Nuwa city allows you to contact more families with nuwa robots.',
        developer_banner_store_text: 'You can develop applications, stories, accessories, etc.And your idea will be used by kids across the country.',
        developer_distribute_plan_title: 'Nu wa developer program',
        developer_distribute_plan_text: 'Nu wa has a wealth of software technology to help developers quickly develop applications and content.',
        developer_distribute_plan03_title: 'Customized development partners',
        developer_distribute_plan03_text: 'Cooperate with nu wa to develop and acquire more resources.We will provide Unity SDK and update service in advance, so that your robot environment and software can be customized and updated as a whole.With our update service, you will save a lot of time, energy and expense to create your unique robot.',
        developer_distribute_plan02_title: 'Advanced development partners',
        developer_distribute_plan02_text: 'In addition to being free to launch your app in the mall, you can also use the simulator provided by nuwa during the redevelopment phase.Through the simulator, you can have a robot environment even if the robot is not around, and continue to create and optimize your app.',
        developer_distribute_plan01_title: 'Platform developer program',
        developer_distribute_plan01_text: 'Launch your app to users all over the country through the shopping mall applicable to nuwa robot.You can also get test tools, development files, and app analysis.Use the App analysis on the Nuwa Developer Console to measure your user engagement and revenue, without the need for additional technical programming support.',
        developer_distribute_plan_update: 'update',
        developer_distribute_plan_unity: 'Unity SDK',
        developer_distribute_plan_store: 'Mall stores',
        developer_distribute_plan_tool: 'Content and development tools',
        developer_distribute_plan_doc: 'Development of file',
        developer_distribute_plan_sdk: 'Download SDK',
        developer_banner_rule_title: 'Guidelines and resources',
        developer_banner_rule_text: 'Read the design and development specifications to learn how to submit and market your application.',
        developer_documataion_overview_00_title: 'Robot development files',
        developer_documataion_overview_01_title: 'introduction',
        developer_documataion_overview_02_title: 'How do applications work on robots?',
        developer_documataion_overview_01_text: 'Nuwa developer platform allows you to add and extend functions on nuwa robot.Users can learn, play games or achieve other goals through dialogue.As a developer, you can use the files and tools provided on the platform to connect your third-party services to create a pleasant experience for users.',
        developer_documataion_overview_02_text: 'When you plan to develop an application for nuwa, you will design a voice, visual interaction application, or service that combines both.Through sound or vision, users can understand your content more clearly and quickly.When the user talks to your application, the process runs in the cloud.',
        // [账号]
        select_category: 'Please select a category',
        countries: 'China',
        company_job_information: 'Company and Job Information',
        basic_information: 'Basic Information',
        submit_info: 'Submit',
        write_plan: 'Write down your plan...',
        proceed: 'Proceed',
        individual_developer: 'Individual developer',
        enterprise_developer: 'Enterprise developer',
        enter_email: 'Please enter email address',
        empty_mailbox: 'The mailbox or password cannot be empty',
        creat_nuwa_account: 'Creat Nuwa Account',
        developer_account_remember_me: 'Remember me',
        developer_account_forget_password: 'Forget password?',
        developer_account_join_developer: 'Join Nuwa Develiper?',
        developer_account_password_warning: 'The password should contain 8-16 words and contain English numerals',
        developer_account_privacy: 'When you sign up for this account, you read, understand and agree to the user agreement and privacy terms.',
        developer_account_have_account: 'Have an account already?',
        developer_account_forget_password_mail: 'Enter your email address to reset your password',
        developer_account_forget_mail: 'If you forgot your email,you can look it up.',
        developer_account_active_mail: 'You’re almost ready to go!Please activate your account.An activate mail has been sent to your email',
        developer_account_active_mail_click: 'Open your account by clicking on a certified letter in your mailbox!',
        developer_account_not_get_mail: 'Have you received the certification letter?',
        developer_account_account_setup_complete: 'Successful account verification!',
        developer_account_setup_log: 'You can use this email address as the login account of nu wa developer',
        developer_account_enter_incorrectly: 'Your ID or password was entered incorrectly.',
        developer_account_description: 'Select your account category',
        developer_account_description_warning: 'The account category cannot be changed after the account is created',
        developer_account_information_real_name: 'Real Name',
        developer_account_information_id: 'Developer Id',
        developer_account_information_country: 'Country / Region',
        developer_account_information_company_name: 'Company Name',
        developer_account_information_category: 'Company Industry',
        developer_account_information_company_scale: 'Company Scale',
        developer_account_information_job_title: 'Your Occupation',
        developer_account_information_website: 'Website',
        developer_account_information_develop_plan_title: 'Develop Plan',
        developer_account_information_develop_plan_text: 'Share with us about the application you want to build. What’s your goal? What kind of services are provided?',
        // [header]
        developmentPlan: 'Develop',
        file: 'File',
        discuss: 'Discuss',
        blog: 'Blog',
        login: 'Login',
        loginOut: 'Logout',
        loginUser: 'User',
        introductionPlatform: 'Introduction',
        developmentProcess: 'Develop Process',
        rulesDocument: 'Rules Document',
        getStarted: 'Get Started',
        instructionsSdk: 'SDK Instructions',
        actionListDescription: 'Motion list',
        nuwaEnterpriseIdentification: 'Nuwa Identification',
        dannyEnterpriseIdentification: 'Danny Identification',
        console: 'Control',
        myConsole: 'Control',
        technicalSupportSdk: 'An easy-to-use SDK for makes to import Nuawa info your android studio project unity IDE',
        technicalSupportMotion: 'View the motions you can inteageare into yourl Nuwa router',
        technicalSupportAction: 'MotionList',
        loginError: 'Your ID or password was entered incorrectly.',
        serverAppears: 'Server appears to be offline'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js